import {
  APPLICATION_STAGE,
  SET_INFO,
  SET_SETTING,
  SET_BRANDING,
  SET_LANGUAGE,
  SET_FRAMES_FEEDBACK,
  SET_TRACKS_FEEDBACK,
} from './mutation-types';

export default {
  [APPLICATION_STAGE](state, payload) {
    state.initialize = [...state.initialize, payload];
  },
  [SET_INFO](state, payload) {
    state.info = payload;
  },
  [SET_SETTING](state, payload) {
    state.setting = payload;
  },
  [SET_BRANDING](state, payload) {
    state.branding = payload;
  },
  [SET_LANGUAGE](state, payload) {
    state.language = payload;
  },
  [SET_FRAMES_FEEDBACK](state, payload) {
    state.feedbackFrames = payload;
  },
  [SET_TRACKS_FEEDBACK](state, payload) {
    state.feedbackTracks = payload;
  },
};
